/**
 * Service quản lý Favicon và Title của trình duyệt
 * Đảm bảo đồng bộ 100% với giao diện ngụy trang đang được chọn (Sheets / Gmail / Zalo / CapCut / Canva)
 * Trạng thái ban đầu trước khi vào web: WorkSpace Pro (Quản lý công việc & Năng suất văn phòng)
 */
export const FAVICONS = {
  // 0. WorkSpace Pro Favicon mặc định khi share link (Biểu tượng Năng suất văn phòng hiện đại)
  DEFAULT: `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'><rect width='32' height='32' rx='8' fill='%232563EB'/><path d='M8 16l5 5L24 10' stroke='%23ffffff' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/></svg>`,

  // 1. Google Sheets Favicon (Bảng tính xanh lá Material 3)
  SHEETS: `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'><path fill='%230F9D58' d='M6 3h14l6 6v20H6z'/><path fill='%2387CEAC' d='M20 3v6h6'/><path fill='%23fff' d='M9 13h14v2H9zm0 4h14v2H9zm0 4h14v2H9z'/></svg>`,

  // 2. Gmail Favicon (Phong bì thư trong giao diện Coogle Wordspeca)
  EMAIL: `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='%23EA4335' d='M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'/></svg>`,

  // 3. Zalo Favicon (Bong bóng chat xanh dương #0068ff chuẩn Zalo)
  ZALO: `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36 36'><path fill='%230068ff' d='M18 3C9.72 3 3 8.82 3 16c0 4.02 2.1 7.62 5.4 9.98V31l5.7-3.1c1.23.27 2.53.42 3.9.42 8.28 0 15-5.82 15-13S26.28 3 18 3z'/><text x='18' y='21' font-family='Arial,sans-serif' font-size='11' font-weight='900' fill='%23fff' text-anchor='middle'>Zalo</text></svg>`,

  // 4. CapCut Favicon (Biểu tượng dựng phim studio chuẩn CapCut)
  CAPCUT: `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'><rect width='32' height='32' rx='7' fill='%230e0e11'/><path d='M8 9l8 7-8 7V9zm16 0l-8 7 8 7V9z' fill='%2300d26a'/></svg>`,

  // 5. Canva Favicon (Biểu tượng chữ C gradient tím Canva)
  CANVA: `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'><circle cx='16' cy='16' r='16' fill='%237d2ae8'/><path d='M21 11.5c-1.2-1-2.9-1.5-5-1.5-4.5 0-8 3.4-8 8s3.5 8 8 8c2.1 0 3.8-.5 5-1.5' fill='none' stroke='%23ffffff' stroke-width='3.2' stroke-linecap='round'/></svg>`,

  // 6. Android Studio Emulator Favicon (Robot Android xanh #3ddc84 trên nền đen-xanh #073042)
  EMULATOR: `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'><rect width='32' height='32' rx='7' fill='%23073042'/><path fill='%233ddc84' d='M8 24c0 .7.6 1.3 1.3 1.3h1.3V29c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3v-3.7h1.6V29c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3v-3.7h1.3c.7 0 1.3-.6 1.3-1.3V11H8v13zM4.7 11c-.7 0-1.3.6-1.3 1.3v9.3c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3v-9.3c0-.7-.6-1.3-1.3-1.3zm22.6 0c-.7 0-1.3.6-1.3 1.3v9.3c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3v-9.3c0-.7-.6-1.3-1.3-1.3zm-6.6-6.5l1.7-1.7c.3-.3.3-.7 0-.9-.3-.3-.7-.3-.9 0l-2 2C18.1 3.3 17 3 16 3s-2.1.3-3.5.9l-2-2c-.3-.3-.7-.3-.9 0-.3.3-.3.7 0 .9l1.7 1.7C8.6 6.3 7 8.7 7 11.5h18c0-2.8-1.6-5.2-4.3-7zM13 7.3c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm6 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z'/></svg>`,

  // 7. Figma Favicon (Biểu tượng 5 màu Figma đặc trưng trên nền tối #1e1e1e)
  FIGMA: `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'><rect width='32' height='32' rx='7' fill='%231e1e1e'/><g transform='translate(8.4, 4.6) scale(0.4)'><path d='M19 28.5a9.5 9.5 0 1 1 19 0 9.5 9.5 0 0 1-19 0z' fill='%231ABCFE'/><path d='M0 47.5A9.5 9.5 0 0 1 9.5 38H19v9.5a9.5 9.5 0 1 1-19 0z' fill='%230ACF83'/><path d='M19 0v19h9.5a9.5 9.5 0 1 0 0-19H19z' fill='%23FF7262'/><path d='M0 9.5A9.5 9.5 0 0 0 9.5 19H19V0H9.5A9.5 9.5 0 0 0 0 9.5z' fill='%23F24E1E'/><path d='M0 28.5A9.5 9.5 0 0 0 9.5 38H19V19H9.5A9.5 9.5 0 0 0 0 28.5z' fill='%23A259FF'/></g></svg>`,

  // 8. Visual Studio Code Favicon (Ruy băng xanh VS Code #007acc trên nền tối #1e1e1e)
  VSCODE: `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'><rect width='32' height='32' rx='7' fill='%231e1e1e'/><path fill='%23007acc' d='M24.7 4.9l-4.9-2.4a1.5 1.5 0 0 0-1.7.3l-9.5 8.6-4.1-3.1a1 1 0 0 0-1.3.1L1.8 9.6a1 1 0 0 0 0 1.4l3.5 3.3-3.5 3.3a1 1 0 0 0 0 1.4l1.4 1.2a1 1 0 0 0 1.3.1l4.1-3.1 9.5 8.6a1.5 1.5 0 0 0 1.7.3l4.9-2.4a1.5 1.5 0 0 0 .9-1.4V6.3a1.5 1.5 0 0 0-.9-1.4zm-6.2 14.5L10.4 14l8.1-5.4v10.8z'/></svg>`
};

export class AppearanceService {
  /**
   * Cập nhật đồng bộ Favicon và Title trên tab trình duyệt
   * @param {string} themeName 'sheets' | 'email' | 'zalo' | 'capcut' | 'canva' | 'emulator' | 'figma' | 'vscode' | 'default'
   * @param {object|null} contextData Dữ liệu truyện hoặc video đang xem (nếu có)
   * @param {boolean} isBossKey Đang kích hoạt chế độ khẩn cấp (Esc)
   */
  static updateAppearance(themeName = 'sheets', contextData = null, isBossKey = false) {
    const validTheme = ['sheets', 'email', 'zalo', 'capcut', 'canva', 'emulator', 'figma', 'vscode', 'default'].includes(themeName) ? themeName : 'sheets';

    // 1. CẬP NHẬT FAVICON TAB TRÌNH DUYỆT
    try {
      let faviconEl = document.querySelector("link[rel*='icon']");
      if (!faviconEl) {
        faviconEl = document.createElement('link');
        faviconEl.rel = 'icon';
        document.head.appendChild(faviconEl);
      }

      if (validTheme === 'sheets') {
        faviconEl.href = FAVICONS.SHEETS;
      } else if (validTheme === 'email') {
        faviconEl.href = FAVICONS.EMAIL;
      } else if (validTheme === 'zalo') {
        faviconEl.href = FAVICONS.ZALO;
      } else if (validTheme === 'capcut') {
        faviconEl.href = FAVICONS.CAPCUT;
      } else if (validTheme === 'canva') {
        faviconEl.href = FAVICONS.CANVA;
      } else if (validTheme === 'emulator') {
        faviconEl.href = FAVICONS.EMULATOR;
      } else if (validTheme === 'figma') {
        faviconEl.href = FAVICONS.FIGMA;
      } else if (validTheme === 'vscode') {
        faviconEl.href = FAVICONS.VSCODE;
      } else {
        faviconEl.href = FAVICONS.DEFAULT;
      }
    } catch (err) {
      console.warn('Lỗi cập nhật favicon:', err);
    }

    // 2. CẬP NHẬT TIÊU ĐỀ TAB TRÌNH DUYỆT (DOCUMENT TITLE)
    try {
      if (isBossKey) {
        // Chế độ khẩn cấp Boss Key: Đưa ngay về bảng tính tài chính Google Sheets an toàn
        document.title = 'Báo_cáo_tài_chính_kiểm_toán_2026.xlsx - Google Trang tính';
        return;
      }

      // Xử lý dữ liệu truyện hoặc video
      const hasStory = contextData && (contextData.truyen_title || contextData.truyenTitle);
      const storyTitle = contextData?.truyen_title || contextData?.truyenTitle || '';
      const chapterTitle = contextData?.chapter_title || contextData?.chapterTitle || '';
      const videoTitle = contextData?.videoTitle || contextData?.title || '';

      if (validTheme === 'sheets') {
        if (hasStory) {
          document.title = `${storyTitle} - ${chapterTitle}.xlsx - Google Trang tính`;
        } else {
          document.title = 'Báo cáo tài chính và KPIs Q3_2026.xlsx - Google Trang tính';
        }
      } else if (validTheme === 'email') {
        if (hasStory) {
          document.title = `[Báo cáo tiến độ] ${storyTitle} (${chapterTitle}) - Gmail`;
        } else {
          document.title = 'Hộp thư đến (2) - ban-dieu-hanh@company.internal - Gmail';
        }
      } else if (validTheme === 'zalo') {
        if (hasStory) {
          document.title = `(3) Team Dự án Q4: ${storyTitle} - Zalo Web`;
        } else {
          document.title = 'Zalo - Nhóm Nội Bộ Dự Án Q4';
        }
      } else if (validTheme === 'capcut') {
        if (videoTitle) {
          document.title = `${videoTitle} - CapCut Web Editor`;
        } else {
          document.title = 'Dự án dựng video_Q3 - CapCut Web Editor';
        }
      } else if (validTheme === 'canva') {
        if (videoTitle) {
          document.title = `${videoTitle} - Canva`;
        } else {
          document.title = 'Thiết kế Video Thuyết trình không tên - Canva';
        }
      } else if (validTheme === 'emulator') {
        if (videoTitle) {
          document.title = `${videoTitle} — Pixel 8 Pro (Emulator)`;
        } else {
          document.title = 'Pixel 8 Pro — Android Studio Emulator';
        }
      } else if (validTheme === 'figma') {
        if (videoTitle) {
          document.title = `${videoTitle} — Figma`;
        } else {
          document.title = 'Figma — Mobile Feed Prototype';
        }
      } else if (validTheme === 'vscode') {
        if (videoTitle) {
          document.title = `${videoTitle} - Visual Studio Code`;
        } else {
          document.title = 'app-architecture.component.ts - Visual Studio Code';
        }
      } else {
        document.title = 'WorkSpace Pro - Nền tảng quản lý công việc và tối ưu năng suất số';
      }
    } catch (err) {
      console.warn('Lỗi cập nhật document title:', err);
    }
  }
}
